import React, { useEffect, useState } from "react";
import { RSelect } from "../Component";
import { branchDropDownData } from "./DropDownData";

export const BranchDropDown = ({
  value,
  isMulti = false,
  isShowAll = false,
  onSelect,
  selectedId,
  placeholder,
  isClearable = false,
  ...props
}) => {
  const [list, setList] = useState();

  useEffect(() => {
    loadBranchList();
    return () => {
      setList();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadBranchList = () => {
    branchDropDownData((data, error) => {
      if (error === null) {
        if (!isShowAll) {
          setList(data);
        } else {
          const allOption = {
            id: 0,
            label: "All Area Manager",
            value: "All",
          };
          setList([allOption, ...data]);
        }
      }
    });
  };
  useEffect(() => {
    if (selectedId && list?.length) {
      const selectedOption = list.find((option) => option.id === selectedId);
      if (selectedOption && selectedOption.id !== value?.id) {
        onSelect(selectedOption);
      }
    }
  }, [list, selectedId, onSelect]);

  const handleChange = (e) => {
    if (!isShowAll) {
      onSelect(e);
    } else {
      if (e === null) {
        const allOption = list?.find((item) => item.id === 0);
        onSelect(allOption);
      } else if (e.id === 0) {
        onSelect(undefined);
      } else {
        onSelect(e);
      }
    }
  };

  const getValue = () => {
    if (value) return value;
    if (isShowAll && list?.length) return list[0];
    return null;
  };

  const showClearIcon = isClearable && !!value && !(value.id === 0 && value.label === "All Area Manager");

  return (
    <RSelect
      options={list ?? []}
      isMulti={isMulti}
      isClearable={showClearIcon}
      placeholder={placeholder}
      value={getValue()}
      onChange={handleChange}
      {...props}
    />
  );
};
